import { render, staticRenderFns } from "./ApplyBetPromoModal.vue?vue&type=template&id=45d064a9&"
import script from "./ApplyBetPromoModal.vue?vue&type=script&lang=js&"
export * from "./ApplyBetPromoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports